import { useState, useEffect } from "react";
import { Container, Text, Box, Image, Center, Spinner, SkeletonCircle } from "@chakra-ui/react";
import axios from "axios";
import Tabs from "../../Components/Tabs/Tabs";

const LiveMatches = () => {

    const [liveMatchData, setLiveMatchData] = useState<any>();
    const [loading, setLoading] = useState(false);

    const FOOTBALL_KEY = process.env.REACT_APP_FOOTBALL_API_KEY;

    useEffect(() => {
        setLoading(true);
        setLoading(true);
        let URL = "https://v3.football.api-sports.io/fixtures?live=all";
        // ! axios config
        let config: any = {
            method: 'get',
            url: URL,
            headers: { 
            'x-rapidapi-host': 'v3.football.api-sports.io', 
            'x-rapidapi-key': `${FOOTBALL_KEY}`
            }
        };

        axios(config)
        .then((result) => {
            // console.log(result);
            setLiveMatchData(result);
        setLoading(false);
        })
        .catch((error)=> {
            console.log(error);
        setLoading(false);
        })
    },[])

    return(
        <Container maxW={["container.xl","container.sm"]} pb="20">

            <Tabs/>

            <Box display="flex">
            <Text mt="5" fontSize="2xl" color="#ffffff" fontWeight="bold">
                Live Matches
            </Text>
            <SkeletonCircle mt="8" ml="3" startColor='red.500' endColor='red.700' size='4' />
            </Box>

            {loading ?
            // if loading is true show loading
            <Center>
            <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.600'
            size='xl'
            mt={["50%","10%"]}
            />
            </Center>
            :
            // if loading is false show result
            <>
            {liveMatchData &&
            <Box>
            {liveMatchData.data.response &&
            <>
            {liveMatchData.data.response.map((data: any) => (
            
            <Box bg="#212121" fontWeight="600" mt="5" color="#ffffff" key={data.fixture.id}>
                <Box display="flex">
                <Text fontSize="xs" ml="2" mt="2">
                    {data.fixture.date.substring(0,10)}
                </Text>
                <Text ml="auto" fontSize="xs" mr="2" mt="2">Score</Text>
                </Box>
                <Box display="flex" px="2" pt="2">
                    <Image
                        boxSize='40px'
                        objectFit='cover'
                        src={data.teams.home.logo}
                        alt='Dan Abramov'
                    />
                    <Text mt="2" ml="2">{data.teams.home.name}</Text>
                    <Text ml="auto" mt="2" mr="2">{data.goals.home}</Text>
                </Box>
                <Box display="flex" px="2" pt="2" pb="2">
                    <Image
                    boxSize='40px'
                    objectFit='cover'
                    src={data.teams.away.logo}
                    alt='Dan Abramov'
                    />
                    <Text mt="2" ml="2">{data.teams.away.name}</Text>
                    <Text ml="auto" mt="2" mr="2">{data.goals.away}</Text>
                </Box>
            </Box>

            ))}
            </>}
            </Box>}
            </>}

        </Container>
    );
}

export default LiveMatches;